module.exports = __webpack_public_path__ + "img/pray.a35937cd.png";